
import store from 'store';
import { message } from 'antd';
import { read } from '../services/api';

const storeKey = 'announcementRead_';

export default {
  namespace: 'announcement',
  state: {
    isRead: true,
    vendorSecret: '',
    isReadBefore: false,
  },
  effects: {
    *acceptVendorSecret({ payload }, { put }) {
      yield put({
        type: 'updateProps',
        payload: {
          vendorSecret: payload,
          isReadBefore: store.get(storeKey + payload) || false
        }
      });
    },
    *markRead({ payload }, { put }) {
      yield put({
        type: 'updateProps',
        payload: {
          isRead: payload
        }
      });
    },
    *agree(_, { put, call, select }) {
      const state = yield select(s => s.announcement);
      const res = yield call(read, { vendorSecret: state.vendorSecret });
      if (res.success) {
        store.set(storeKey + state.vendorSecret, true);
        yield put({
          type: 'updateProps',
          payload: {
            isReadBefore: true
          }
        });
        message.info('感谢您的支持和配合！');
      } else {
        res.msg && message.error(res.msg);
      }
    }
  },
  reducers: {
    updateProps(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    }
  }
};
